module.exports = __webpack_public_path__ + "static/media/draft-icon.2fe86ec2.svg";